import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { axiosClient, useAxios } from "auth-sdk";
import type { BankConnectSchema, BankingScreen, BankingSettings } from "bankconnect";

import { BANK_CONNECT_API, BANK_CONNECT_SOURCES_API } from "../../components/constants";

export type BankConnectScreenProps = { initialScreen: BankingScreen; bankConnectProps: BankConnectSchema };
export const useBankConnectProps = (companySlug: string) => {
  return useSuspenseQuery({
    ...bankConnectScreenPropsOptions(companySlug),
    select: ({ data }): BankConnectScreenProps => {
      // Temporarily hardcode the path that connection + statement summary card "Add connection" button directs to,
      // so we avoid changing BE bankconnect service code
      data.bankConnectProps.bankSettings.bankingScreenPath = `/${companySlug}/funding/application/connections/banking`;
      return { ...data };
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const bankConnectScreenPropsOptions = (companySlug: string) => {
  const fetchUrl = BANK_CONNECT_API.replace(":customerSlug", companySlug);

  const queryFn = () => axiosClient.get<BankConnectScreenProps>(fetchUrl);
  return queryOptions({
    queryKey: [fetchUrl, companySlug],
    queryFn,
    select: ({ data }) => data,
  });
};

// Returns of banking data sources and bank statement group data
export const useBankingSources = (companySlug: string) => {
  const client = useAxios();
  const fetchUrl = BANK_CONNECT_SOURCES_API.replace(":customerSlug", companySlug);
  const queryFn = () => client.get<BankingSettings>(fetchUrl);
  return useSuspenseQuery({
    queryKey: [fetchUrl, companySlug],
    queryFn,
    select: ({ data }): BankingSettings => {
      return { ...data };
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
